import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CartIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M2 3H3.1C3.6 3 4 3.4 4.1 3.8L5.7 14.3C5.9 15.3 6.7 16 7.7 16H19"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 21.5C8.82843 21.5 9.5 20.8284 9.5 20C9.5 19.1716 8.82843 18.5 8 18.5C7.17157 18.5 6.5 19.1716 6.5 20C6.5 20.8284 7.17157 21.5 8 21.5Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 21.5C17.8284 21.5 18.5 20.8284 18.5 20C18.5 19.1716 17.8284 18.5 17 18.5C16.1716 18.5 15.5 19.1716 15.5 20C15.5 20.8284 16.1716 21.5 17 21.5Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 13H19.2C19.6 13 20 12.7 20.2 12.3L21.6 7.3C21.8 6.7 21.3 6 20.6 6H5"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

CartIcon.displayName = 'CartIcon';
